import { gzip, ungzip } from 'pako';
import { Logger } from '../logger/logger';

export class Compression {

    public static compress(buffer: string): Uint8Array | undefined {
        try {
            return gzip(buffer);
        } catch (error) {
            Logger.error(`Gzip Failed with ${error}`)
        }
        return undefined;
    } // compress()

    public static decompress(buffer: Uint8Array): string | null {
        try {
            return ungzip(buffer, { to: 'string' });;
        } catch (error) {
            Logger.error(`Unzip Failed with ${error}`)
        }
        return null;
    } // decompress()    

}
